var DialogVoucherData = /** @class */ (function () {
    function DialogVoucherData() {
        this.nations = new Map();
    }
    DialogVoucherData.prototype.addNation = function (nation, entryRequirement) {
        this.nations.set(nation, entryRequirement);
    };
    DialogVoucherData.prototype.getNation = function (nation) {
        return this.nations.get(nation);
    };
    DialogVoucherData.prototype.getNations = function () {
        var result = [];
        this.nations.forEach(function (nation, key) {
            result.push(key);
        });
        return result;
    };
    return DialogVoucherData;
}());
export { DialogVoucherData };
export default DialogVoucherData;
